import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';

export class ANServiceEndPoints {
  static BULK_SEARCH = 'BULK_SEARCH';
  static GET_APP_MASTER_TYPE = 'GET_APP_MASTER_TYPE';
  static SUBJECT_SEARCH = 'SUBJECT_SEARCH';
  static IMAGE_GET = 'IMAGE_GET';
  static DS_IN_DG = 'DS_IN_DG';
  static MM_ANALYTICS = 'MM_ANALYTICS';
  static SKILLI8_ANALYTICS = 'SKILLI8_ANALYTICS';
  static DEFECTS_LIST = 'DEFECTS_LIST';
}

@Injectable({
  providedIn: 'root',
})
export class AnEnvProvider {
  public svc_host = '';
  public data_gateway = '/no_data_gateway';
  public core_service = '/no_core_service';
  public license_service = '/no_license_service';
  public image_service = '/no_image_service';
  public protocol = '';

  private env_vars: any = new Object();

  constructor() {
    // console.log('Setting AuthModule CONST with ENV VAR');

    if (environment.protocol) {
      this.protocol = environment.protocol;
    }

    if (environment.service_host) {
      this.svc_host = environment.service_host;
    }
    if (environment.data_gateway) {
      this.data_gateway = environment.data_gateway;
    }
    if (environment.core_service) {
      this.core_service = environment.core_service;
    }
    if (environment.core_service) {
      this.core_service = environment.core_service;
    }
    if (environment.image_service) {
      this.image_service = environment.image_service;
    }

    // register all vars
    this.registerVars();
  }

  private registerVars() {
    this.env_vars[ANServiceEndPoints.BULK_SEARCH] = this.protocol + this.svc_host + this.data_gateway + '/v3/search';
    this.env_vars[ANServiceEndPoints.GET_APP_MASTER_TYPE] =
      this.protocol + this.svc_host + this.license_service + '/activation/appmaster/type';
    this.env_vars[ANServiceEndPoints.GET_APP_MASTER_TYPE] =
      this.protocol + this.svc_host + this.license_service + '/activation/appmaster/type';
    this.env_vars[ANServiceEndPoints.SUBJECT_SEARCH] = this.protocol + this.svc_host + this.core_service + '/subjects';
    this.env_vars[ANServiceEndPoints.DS_IN_DG] = this.protocol + this.svc_host + this.data_gateway + '/lite/ds/v2';
    this.env_vars[ANServiceEndPoints.IMAGE_GET] =
      this.protocol +
      this.svc_host +
      this.image_service +
      '/dataman/getsiluhoutteimageDashBoard?subject_key=$sk&siluhoutteName=$name';
    this.env_vars[ANServiceEndPoints.MM_ANALYTICS] =
      this.protocol + this.svc_host + this.data_gateway + '/mm_analytics/config';
    this.env_vars[ANServiceEndPoints.SKILLI8_ANALYTICS] =
      this.protocol + this.svc_host + this.data_gateway + '/skilli8_analytics/config';
    this.env_vars[ANServiceEndPoints.DEFECTS_LIST] =
      this.protocol + this.svc_host + this.data_gateway + '/api/v1/showCapturedImages';
  }

  public getEnvVar(arg: string): string {
    return this.env_vars[arg];
  }
}
